// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"1d523a00378ebd68c5b3","4520":"30cf3f898e2ecd996463","5948":"06d2a0d84620cba6a4fb","6464":"169260b661120cc50815"}[chunkId] + ".css";
};